import { useMutation, useQueryClient } from '@tanstack/react-query';

import { setWorkspaceQuizSharing } from '../../../api/workspaces/quizzes/setWorkspaceQuizSharing';
import { workspaceKeys } from './workspaceQueryKeyFactory';

interface UseSetWorkspaceQuizSharingParams {
  workspaceId: string;
  workspaceQuizId: string;
}

export function useSetWorkspaceQuizSharing({
  workspaceId,
  workspaceQuizId,
}: UseSetWorkspaceQuizSharingParams) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (sharable: boolean) =>
      setWorkspaceQuizSharing({ workspaceId, workspaceQuizId, sharable }),
    // Refetch the quiz so the dialog reflects the persisted sharable/soc value
    // (and the locked sentinel doesn't leave a stale optimistic state).
    onSettled: () => {
      queryClient.invalidateQueries(
        workspaceKeys.byWorkspaceQuizId({ workspaceQuizId, workspaceId })
      );
    },
  });
}
